import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export function currencyFormat(num) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "".concat(num.toFixed(decimals).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'));
}